import React, {useState} from "react";
import UsageTableSection from "./usageTableSection";
import BillsTableSection from "./BillsTableSection";
import ComponentHeader from "../CommonComponents/componentHeader";
import styles from "./billingPageWrapper.module.css";
import {cx} from "../../Util/classHelpers";

const BILLING_COMPONENT = "BILLING_COMPONENT";

const BillingPageWrapper = () => {
    const [activeTab, setActiveTab] = useState("usage");

    return (
        <>
            <ComponentHeader title={"Billing & Usage"}/>
            <div className={styles.pageContent}>
                <div className={styles.tabsContainer}>
                    <div className={styles.tabs} role="tablist" aria-label="Billing and usage">
                        <button
                            className={cx(styles.tab, styles.usageTab, activeTab === "usage" && styles.activeTab)}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "usage"}
                            onClick={() => setActiveTab("usage")}
                        >
                            Usage
                        </button>
                        <button
                            className={cx(styles.tab, styles.billsTab, activeTab === "bills" && styles.activeTab)}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "bills"}
                            onClick={() => setActiveTab("bills")}
                        >
                            Bills
                        </button>
                    </div>
                    <div
                        className={cx(styles.slider, activeTab === "bills" && styles.sliderRight)}
                        aria-hidden="true"
                    />
                </div>
                <div role="tabpanel">
                    {activeTab === "usage" ? <UsageTableSection/> : <BillsTableSection/>}
                </div>
            </div>
        </>
    )
}

export default BillingPageWrapper;
export {BILLING_COMPONENT};
